import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import {
  POLICY_DESC,
  POLICY_DESC_ES,
  POLICY_TITLE,
  POLICY_TITLE_ES
} from '../../constants/defaults';
import _ from 'lodash';

const PrivacyPolicy = props => {
  let data;
  if (typeof window !== 'undefined' && typeof __INITIAL_DATA__ !== 'undefined')
    data = window.__INITIAL_DATA__;
  else data = props.staticContext.data;
  const { i18n } = useTranslation();
  let isEs = _.isEqual(i18n.language, 'es');
  return (
    <main>
      <Helmet>
        <meta
          name="ROBOTS"
          content="NOINDEX, FOLLOW, NOSNIPPET, NOODP, NOYDIR"
        />
        <title>{isEs ? POLICY_TITLE_ES : POLICY_TITLE}</title>
        <meta
          name="description"
          content={isEs ? POLICY_DESC_ES : POLICY_DESC}
        />
        <link
          rel="alternate"
          href="https://www.singlecare.com/privacy-policy"
          hrefLang="en-us"
        />
        <link
          rel="alternate"
          href="https://www.singlecare.com/es/politicas-de-privacidad-singlecare"
          hrefLang="es-us"
        />
        <link
          rel="canonical"
          href={`https://www.singlecare.com${props.location.pathname}`}
        />
      </Helmet>
      <div
        id="static-page-content"
        dangerouslySetInnerHTML={{
          __html: data?.content
        }}
      ></div>
    </main>
  );
};

export default PrivacyPolicy;
